/*eslint-disable */
var clearTimeoutState;
const $ = window.jQuery = require('jquery');

import Multiselect from 'vue-multiselect'
import allCountries from './phoneCodeList.json';
import blurbContentInfo from '@/components/public/blurb-content-for-lymphomap-signup/';
import {bus} from '@/main';
import countries from '@/services/country.json';
import guestUserForPopup from '@/components/authentication/guest-user-for-popup/';
import resendOtpPopup from '@/components/authentication/resend-otp-popup/';
import retryOtpBlurb from '@/components/authentication/otp-retry-blurb-popup/';
import toast from '@/services/toast';

export default {
  name: 'registration-form',
  components: {
    Multiselect,
    'blurb-content':blurbContentInfo,
    'resend-otp': resendOtpPopup,
    'guest-user-popup': guestUserForPopup,
    'retry-otp-blurb' : retryOtpBlurb
  },
  props: [],
  data () {
    return {
      submitted:false,
      first_name:'',
      last_name:'',
      email:'',
      organization:'',
      division:'',
      area_of_work:'',
      department:'',
      designation:'',
      countryList: [],
      country:'',
      city:'',
      allCountriesList:[],
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      userFilter:'',
      name_prefix:'',
      name_prefix_updated:'',
      prefix_dr_specialties:'',
      userFilter:'',
      accept_terms:'',
      other_doctor_cat:'',
      enabled_other_d_cat:false,
      professional_category:'',
      countryPrint:'',
      areaOfSpecialization:'',
      phoneNumber:{
        fullOTP:''
      },
      signUpFormMain:true,
      signUpFormVerify:false,
      signUpFormVerifyPopup:false,
      memberAllFilterList:{},
      memberAllFilterListResults:[],
      extraSubCatState:[],
      blurTextbPopupState:false,
      license:{
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      registrationPortal:'',
      uploadLicenseFile:null,
      uploadLicenseFileName:'',
      countDown: 30,
      resentOtpFlag:false,
      signup_counter:0,
      resendOtpPopupState:false,
      guestUserPopupState:false,
      phoneNumberBlurState:false,
      retryOtpPopupState:false,
      otp_retry:1,
      userInfo:{
        name:'',
        email:''
      },
      otpFieldError:false,
      otpFieldErrorText:'',
      password:'',
      confirm_password:'',
      has_number:false,
      has_lowercase:false,
      has_uppercase:false,
      has_special:false
    }
  },
  computed: {

  },
  mounted () {
    this.getUserCountry();
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key],
        value: key
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    $('.option-list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.option-list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
    $('.license_for_list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.license_for_list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
    this.getProfessionCategoriesListMethods()
    bus.$on('blurTextbPopupStateBus', (data) => {
      this.blurTextbPopupState = data
    });
    bus.$on('resendOTPLimitStateBus', (data) => {
      this.resendOtpPopupState = data
    });
    bus.$on('guestUserPopupStateBus', (data) => {
      this.guestUserPopupState = data
    });
    bus.$on('retryOtpPopupStateBus', (data) => {
      this.retryOtpPopupState = data
      // if(data == false){
      //   this.signUpFormMain = true
      //   this.signUpFormVerify = false
      // }
    });
  },
  methods: {
    passwordValidatorMethod(){
        this.has_number = /\d/.test(this.password);
        this.has_lowercase = /[a-z]/.test(this.password);
        this.has_uppercase = /[A-Z]/.test(this.password);
        this.has_special = /[#?!@$%^&*-]/.test(this.password);
        this.password = this.password.replace(/\s/g,'')
    },
    retryOtpPopupOpenMethod(){
      this.retryOtpPopupState = true
      document.body.classList.add('popup_open_body')
    },
    popupCloseEventMethod(){
      this.$router.push('/');
    },
    phoneNumberFocusMethod(){
      this.phoneNumberBlurState = true
    },
    phoneNumberBlurMethod(){
      this.phoneNumberBlurState = false
    },
    resendOtpMethod() {
          this.otpFieldError = false
          this.otpFieldErrorText = ''
          let signup_counter = this.signup_counter + 1
          this.signup_counter = signup_counter
          let data = {
            first_name:this.first_name,
            last_name:this.last_name,
            email:this.email,
            area_of_work:this.area_of_work,
            department:this.department,
            country: this.country.value,
            city: this.city,
            mobile_country_code:'+' + this.phone.countryCode,
            mobile:this.phone.number,
            salutation:this.name_prefix_updated,
            professional_filter_category:this.professional_category,
            professional_filter_name:this.areaOfSpecialization,
            signup_counter:this.signup_counter,
            password:this.confirm_password
          }
          if(this.prefix_dr_specialties != null && this.prefix_dr_specialties != ''){
            data.prefix_dr_specialties = this.prefix_dr_specialties;
          }
          if(this.other_doctor_cat != null && this.other_doctor_cat != ''){
            data.professional_category = this.other_doctor_cat;
          }
          if(this.registrationPortal != ''){
            data.license_portal = this.registrationPortal;
          }
          if(this.license.number != ''){
            data.license_value = this.license.number;
            data.license_country_code = this.license.countryCode;
          }
          this.$store.dispatch('NewUserSignUpFun', data)
            .then((res) => {  
              toast.success(res.data.user_msg || res.data.msg);
              this.countDown = 30
              this.countDownTimer();
              this.resentOtpFlag = true
            }).catch((err) => {
              this.resendOtpPopupState = true
              document.body.classList.add('body_right_scroll_remove')
              toast.error(err.data.data.non_field_errors || err.data.msg);
            })
          return;
    },
    countDownTimer() {
      if(this.countDown > 0) {
        clearTimeoutState = setTimeout(() => {
                this.countDown -= 1
                this.countDownTimer()
            }, 1000)
        }
    },
    handleUploadLicenseFile(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.uploadLicenseFile = event.target.files[0];
        this.uploadLicenseFileName = this.uploadLicenseFile.name
      }else {
        this.uploadLicenseFileName = '';
      }
    },
    getProfessionCategoriesListMethods(){
      this.$store.dispatch('getMemberFilterListForSignupFun')
        .then((res) => {  
          this.memberAllFilterList = res.data.data
          if(this.memberAllFilterList != undefined){
            this.memberAllFilterListResults = this.memberAllFilterList.results
          }
        }).catch((err)=>{
        })
    },
    validateSignVerifyBeforeSubmit(){
      this.otpFieldErrorText = ''
      this.otpFieldError = false
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            mobile_country_code:'+' + this.phone.countryCode,
            mobile:this.phone.number,
            otp:this.phoneNumber.fullOTP,
            otp_retry:this.otp_retry
          }
          this.$store.dispatch('webUserVerificationAction', data)
            .then((res) => {  
              this.otpFieldError = false
              toast.success(res.data.msg);
              this.signUpFormVerify = false
              this.signUpFormVerifyPopup = true
              this.submitted =  false
            }).catch((err) => {
              // toast.error(err.data.user_msg || err.data.data);
              this.submitted =  false
              this.otp_retry = this.otp_retry + 1
              // if(this.otp_retry == 4){
              //   this.retryOtpPopupState = true
              //   document.body.classList.add('popup_open_body')
              // }
              this.otpFieldError = true
              this.otpFieldErrorText = err.data.user_msg
            })
          return;
        }
      })
    },
    validateSignBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          this.userInfo.name = this.first_name + ' ' + this.last_name
          this.userInfo.email = this.email
          let data = {
            first_name:this.first_name,
            last_name:this.last_name,
            email:this.email,
            area_of_work:this.area_of_work,
            department:this.department,
            country: this.country.value,
            city: this.city,
            mobile_country_code:'+' + this.phone.countryCode,
            mobile:this.phone.number,
            salutation:this.name_prefix_updated,
            professional_filter_category:this.professional_category,
            professional_filter_name:this.areaOfSpecialization,
            signup_counter:0,
            password:this.confirm_password
          }
          if(this.prefix_dr_specialties != null && this.prefix_dr_specialties != ''){
            data.prefix_dr_specialties = this.prefix_dr_specialties;
          }
          if(this.other_doctor_cat != null && this.other_doctor_cat != ''){
            data.professional_category = this.other_doctor_cat;
          }
          if(this.registrationPortal != ''){
            data.license_portal = this.registrationPortal;
          }
          if(this.license.number != ''){
            data.license_value = this.license.number;
            data.license_country_code = this.license.countryCode;
          }
          this.$store.dispatch('NewUserSignUpFun', data)
            .then((res) => {  
              if(this.uploadLicenseFile){
                let formData = new FormData();
                formData.append('license_file', this.uploadLicenseFile);
                this.$store.dispatch('uploadLicenseFileOfDoctorMethod', formData)
              }
              this.$store.dispatch('authUserAgreementFun', { user:this.email, from_page: "signup" } )
              toast.success(res.data.msg);
              this.signUpFormMain = false
              this.signUpFormVerify = true
              this.submitted =  false
              this.countDownTimer()
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.email || err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
            self.license.countryIso = (text.substr(2, 2)).toLowerCase();
            self.license.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    chooseCountryForLicense(country) { 
      this.license.countryIso = country.iso2;
      this.license.countryCode = country.dialCode
    },
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    selectedCountryFun(val, valName){
      this.country = val
      this.countryPrint = valName
    },
    titleChangedMethod(name, val){
      this.name_prefix = name
      if(val == 'Medical_Doctor'){
        this.name_prefix_updated = 'Dr'
        this.prefix_dr_specialties = 'Medical Doctor'
        this.blurTextbPopupState = true
      }else if(val == 'PhD_Doctor'){
        this.name_prefix_updated = 'Dr'
        this.prefix_dr_specialties = 'PhD Doctorate'
      }else{
        this.name_prefix_updated = val
        this.prefix_dr_specialties = ''
      }
    },  
    professionSelectCatFun(filterKey,filterCatVal,filterSubCatVal){
      if(filterKey == 'Guest'){
        this.guestUserPopupState = true
        document.body.classList.add('popup_open_body')
      }else{
        this.guestUserPopupState = false
        document.body.classList.remove('popup_open_body')
      }
        this.professional_category = filterKey
        this.areaOfSpecialization = filterCatVal
        if(filterSubCatVal.length > 0){
          this.enabled_other_d_cat = true
          this.extraSubCatState = filterSubCatVal
        }else{
          this.enabled_other_d_cat = false
          this.other_doctor_cat = ''
        }
    },
    otherDoctorSelectCatFun(ODFilterVal){
      this.other_doctor_cat = ODFilterVal
    }
  }
}


